export default __webpack_public_path__ + "static/media/zbyg5.a86fa399.jpg";